import { render } from "./WCBottomNavigation.vue?vue&type=template&id=b85c24e0&scoped=true"
import script from "./WCBottomNavigation.vue?vue&type=script&lang=js"
export * from "./WCBottomNavigation.vue?vue&type=script&lang=js"

import "./WCBottomNavigation.vue?vue&type=style&index=0&id=b85c24e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b85c24e0"]])

export default __exports__